export default __webpack_public_path__ + "img/BqHFaykW.7e0d264b.svg";